'use client';

import * as React from 'react';

interface CustomChatHeaderProps {
  participantCount?: number;
  roomName?: string;
}

export function CustomChatHeader({ participantCount = 0, roomName }: CustomChatHeaderProps) {
  const [isMinimized, setIsMinimized] = React.useState(false);

  const toggleChat = () => {
    setIsMinimized(!isMinimized);
    window.dispatchEvent(new CustomEvent('chat-toggle', { detail: { minimized: !isMinimized } }));
  };

  const closeChat = () => {
    window.dispatchEvent(new CustomEvent('chat-close'));
  };

  return (
    <div
      style={{
        backgroundColor: '#2a2a2a',
        borderBottom: '1px solid #404040',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 16px',
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '16px',
            fontWeight: '600',
            color: '#ffffff',
            lineHeight: '1',
          }}
        >
          Bate-papo
        </h3>

        <button
          onClick={closeChat}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            color: '#9ca3af',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#9ca3af';
          }}
          title="Fechar chat"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6L6 18M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div
        style={{
          display: 'flex',
          borderBottom: '1px solid #404040',
        }}
      >
        <div
          style={{
            flex: 1,
            padding: '8px 16px',
            backgroundColor: 'transparent',
            borderBottom: '2px solid #3b82f6',
            cursor: 'pointer',
            textAlign: 'center',
          }}
        >
          <span
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#3b82f6',
            }}
          >
            Conversa
          </span>
        </div>

        {/* <div
          style={{
            flex: 1,
            padding: '8px 16px',
            backgroundColor: 'transparent',
            borderBottom: '2px solid transparent',
            cursor: 'not-allowed',
            textAlign: 'center',
            opacity: 0.5,
          }}
        >
          <span
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#9ca3af',
            }}
          >
            Votações
          </span>
        </div> */}
      </div>
    </div>
  );
}
